/**
 * Convert kebab-case and snake_case object keys to camelCase recursively.
 * lumina-api uses snake_case responses; the frontend uses camelCase throughout.
 */
function toCamel(str: string): string {
  return str.replace(/[-_]([a-z0-9])/g, (_, ch) => ch.toUpperCase());
}

export function normalizeKeys<T>(obj: unknown): T {
  if (Array.isArray(obj)) {
    return obj.map((item) => normalizeKeys(item)) as unknown as T;
  }
  if (obj !== null && typeof obj === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
      result[toCamel(key)] = normalizeKeys(value);
    }
    return result as T;
  }
  return obj as T;
}
